import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';

export default function NavBar() {
  const [navbarOpen, setNavbarOpen] = useState(false);

  function toggleNavbar() {
    setNavbarOpen(!navbarOpen);
  }

  return (
    <Navbar color="light" expand="md" light>
      <Link to="/" style={{ textDecoration: 'none' }}>
        <NavbarBrand>
          <img
            src="https://raw.githubusercontent.com/DiestroCorleone/diestrocode-blog-assets/main/icon-md.png"
            className="img-sm"
            style={{ marginRight: '10px' }}
          />
          <span className="font-secondary">DiestroCode</span>
        </NavbarBrand>
      </Link>
      <NavbarToggler onClick={() => toggleNavbar()} />
      <Collapse navbar isOpen={navbarOpen}>
        <Nav className="me-auto" navbar>
          <Link to="/" exact style={{ textDecoration: 'none' }}>
            <NavItem>
              <NavLink>Úlitmos posts</NavLink>
            </NavItem>
          </Link>
          <Link to="/sobre-mi" exact style={{ textDecoration: 'none' }}>
            <NavItem>
              <NavLink>Sobre mí</NavLink>
            </NavItem>
          </Link>
        </Nav>
      </Collapse>
    </Navbar>
  );
}
